export function convertBase64ToFile(base64File) {
  const byteCharacters = atob(base64File);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  var file = new Blob([byteArray], { type: "application/octet-stream; base64" });

  var fileURL = URL.createObjectURL(file);

  return fileURL;
}
